export enum PMSType {
    None = 0,
    Opera = 1,
    LodgingLink = 2,
}